// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TracewayTestCrashRouteImport } from './routes/traceway-test-crash'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as IndexRouteImport } from './routes/index'
import { Route as KnowledgeBaseIndexRouteImport } from './routes/knowledge-base/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as LegalSlugRouteImport } from './routes/legal/$slug'
import { Route as KnowledgeBaseSplatRouteImport } from './routes/knowledge-base/$'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductsSharedHostingRouteImport } from './routes/products/shared-hosting'
import { Route as ProductsHostingRouteImport } from './routes/products/hosting'
import { Route as ProductsCategoryRouteImport } from './routes/products/$category'
import { Route as ProductsWebHostingIndexRouteImport } from './routes/products/web-hosting/index'
import { Route as ProductsWebHostingSharedHostingRouteImport } from './routes/products/web-hosting/shared-hosting'
import { Route as ProductsApplicationPlatformHostedDatabasesRouteImport } from './routes/products/application-platform/hosted-databases'
import { Route as ProductsApplicationPlatformApplicationHostingRouteImport } from './routes/products/application-platform/application-hosting'
import { Route as ProductsCategoryIndexRouteImport } from './routes/products/$category/index'

const TracewayTestCrashRoute = TracewayTestCrashRouteImport.update({
            id: '/traceway-test-crash',path: '/traceway-test-crash',getParentRoute: () => rootRouteImport
          })
const ProductsRoute = ProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const KnowledgeBaseIndexRoute = KnowledgeBaseIndexRouteImport.update({
            id: '/knowledge-base/',path: '/knowledge-base/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const LegalSlugRoute = LegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => rootRouteImport
          })
const KnowledgeBaseSplatRoute = KnowledgeBaseSplatRouteImport.update({
            id: '/knowledge-base/$',path: '/knowledge-base/$',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsIndexRoute = ProductsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductsRoute
          })
const ProductsSharedHostingRoute = ProductsSharedHostingRouteImport.update({
            id: '/shared-hosting',path: '/shared-hosting',getParentRoute: () => ProductsRoute
          })
const ProductsHostingRoute = ProductsHostingRouteImport.update({
            id: '/hosting',path: '/hosting',getParentRoute: () => ProductsRoute
          })
const ProductsCategoryRoute = ProductsCategoryRouteImport.update({
            id: '/$category',path: '/$category',getParentRoute: () => ProductsRoute
          })
const ProductsWebHostingIndexRoute = ProductsWebHostingIndexRouteImport.update({
            id: '/web-hosting/',path: '/web-hosting/',getParentRoute: () => ProductsRoute
          })
const ProductsWebHostingSharedHostingRoute = ProductsWebHostingSharedHostingRouteImport.update({
            id: '/web-hosting/shared-hosting',path: '/web-hosting/shared-hosting',getParentRoute: () => ProductsRoute
          })
const ProductsApplicationPlatformHostedDatabasesRoute = ProductsApplicationPlatformHostedDatabasesRouteImport.update({
            id: '/application-platform/hosted-databases',path: '/application-platform/hosted-databases',getParentRoute: () => ProductsRoute
          })
const ProductsApplicationPlatformApplicationHostingRoute = ProductsApplicationPlatformApplicationHostingRouteImport.update({
            id: '/application-platform/application-hosting',path: '/application-platform/application-hosting',getParentRoute: () => ProductsRoute
          })
const ProductsCategoryIndexRoute = ProductsCategoryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductsCategoryRoute
          })





const ProductsCategoryRouteChildren = {
  ProductsCategoryIndexRoute: ProductsCategoryIndexRoute
}

const ProductsCategoryRouteWithChildren = ProductsCategoryRoute._addFileChildren(ProductsCategoryRouteChildren)



const ProductsRouteChildren = {
  ProductsCategoryRoute: ProductsCategoryRouteWithChildren,ProductsHostingRoute: ProductsHostingRoute,ProductsSharedHostingRoute: ProductsSharedHostingRoute,ProductsIndexRoute: ProductsIndexRoute,ProductsApplicationPlatformApplicationHostingRoute: ProductsApplicationPlatformApplicationHostingRoute,ProductsApplicationPlatformHostedDatabasesRoute: ProductsApplicationPlatformHostedDatabasesRoute,ProductsWebHostingSharedHostingRoute: ProductsWebHostingSharedHostingRoute,ProductsWebHostingIndexRoute: ProductsWebHostingIndexRoute
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(ProductsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContactRoute: ContactRoute,ProductsRoute: ProductsRouteWithChildren,TracewayTestCrashRoute: TracewayTestCrashRoute,BlogSlugRoute: BlogSlugRoute,KnowledgeBaseSplatRoute: KnowledgeBaseSplatRoute,LegalSlugRoute: LegalSlugRoute,BlogIndexRoute: BlogIndexRoute,KnowledgeBaseIndexRoute: KnowledgeBaseIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)